module.exports = __webpack_public_path__ + "static/img/hardWare8.6be81f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/hardware/hardWare8.png
// module id = SP/y
// module chunks = 0